
import React, { useCallback, useMemo, useState } from 'react'

export const _seasonPasteTypes = {
  roster: 'roster',
  staff: 'staff',
}

const requiredHeaders = {
  roster: [
    "#",
    "lastName",
    "firstName",
    // "year",
    "graduationYear",
    "playerPosition",
    "height"
  ],
  staff: [
    "lastName",
    "firstName",
    "position",
  ]
};

export const SeasonPaste = ({ roster, handle_paste, seasonPasteType, currentSeason }) => {

  const [currentPaste, setCurrentPaste] = useState()

  const normalizeHeader = (header) => {

    switch (header) {
      case '#':
        return 'uniformNumber'
      default:
        const camel = _.camelCase(header);

        switch (camel) {
          case "#":
            return 'uniformNumber'

          case "position":
            return "playerPosition";

          case "gradYear":
          case "graduation":
            return "graduationYear";

          default:
            return camel;
        }
    }

  };

  const getMaxYear = (parsed, headers) => {
    const roster = _(parsed)
      .drop(1)
      .filter(row => _.some(row))
      .map(cols => {
        const player = _.zipObject(headers, cols);

        const playerKey = [
          _.toLower(_.trim(player.lastName)),
          _.toLower(_.trim(player.firstName)),
          player.graduationYear
        ].join("_");

        return {
          ..._.omit(player, [
            "uniformNumber",
            "height",
            "playerPosition"
          ]),
          playerKey,
        };
      })
      .keyBy("playerKey")
      .value();
    const maxGradYear = _.min(
      _.map(roster, 'graduationYear')
    );
    console.log('maxGradYear!!!', maxGradYear)
    return maxGradYear
  }

  const handlePaste = useCallback((e) => {

    e.preventDefault();

    const text = e.clipboardData.getData("text");

    if (!text) return;

    const parsed = text
      .trim()
      .split(/\r?\n/)
      .map(row => row.split("\t").map(cell => cell.trim()));

    const headers = parsed[0].map(normalizeHeader);

    const maxGradYear = getMaxYear(parsed, headers)

    const _currentSeason = maxGradYear || currentSeason

    const roster = _(parsed)
      .drop(1)
      .filter(row => _.some(row))
      .map(cols => {
        const player = _.zipObject(headers, cols);

        const playerKey = [
          _.toLower(_.trim(player.lastName)),
          _.toLower(_.trim(player.firstName)),
          player.graduationYear
        ].join("_");

        return {
          ..._.pick(player, requiredHeaders.roster),
          playerKey,
          seasons: {
            [_currentSeason]: {
              uniformNumber: player.uniformNumber,
              height: player.height,
              positions: _.uniq(
                _.compact(
                  _.castArray(player.playerPosition)
                )
              )
            }
          }
        };
      })
      .keyBy("playerKey")
      .value();

    console.log('newRoster', _.size(roster), roster)
    setCurrentPaste(roster)
    handle_paste(roster);

  }, [currentSeason]);

  const missingHeaders = useMemo(() => {

    if (!roster?.length) return requiredHeaders[seasonPasteType];

    const existingHeaders = Object.keys(roster?.[0]);

    return _.difference(requiredHeaders[seasonPasteType], existingHeaders);
  }, [roster]);

  const paste = () => {
    return <div>
      <div
        onPaste={handlePaste}
        contentEditable
        suppressContentEditableWarning
        style={{
          minHeight: 60,
          border: '2px dashed var(--off-white-5)',
          borderRadius: 8,
          padding: 10,
          background: 'var(--off-black-3)',
          outline: 'none'
        }}
      >
        Copy rows from Excel or Google Sheets and paste here...
      </div>
      {
        !!missingHeaders.length && !_.isEmpty(currentPaste) && (
          <div style={{ color: 'var(--off-white-5)', marginTop: 10 }}>
            Missing headers: {missingHeaders.join(', ')}
          </div>
        )
      }
    </div >
  }

  return paste()

}
